import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import Background from '../../../static/images/american-express/img-3-desktop.jpg'
import BackgroundM from '../../../static/images/american-express/img-3-mobile.jpg'



const Container = styled.div`
  position: relative;
  text-align: center;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-size: cover !important;
  background-size: contain !important;
  height: 160px;
  background-image:url(${BackgroundM});

  h1 {
    font-size: 2em;
    margin: 0 0 0.3em;
    color:white;
    display:none;
  }

  h2 {
    font-size: 1.2em;
    font-weight: 400;
    color: ${props => props.theme.colors.grisOscuro};
    margin: 0 0 0.5em;
  }

  p {
    color: ${props => props.theme.colors.grisOscuro};
    margin-bottom: 0 0 1.5em;
  }

  ${breakpoint('tablet')`
     background-image:url(${Background});
     height:300px !important;
     background-size: cover !important;

     h1 {
        font-size: 3em;
        font-weight: 400;
        margin-top: 33px;
        margin-bottom: -37px;
        display:block;
     }
`}  

  ${breakpoint('desktop')`
    background-position-x: 0;
 
    h1{
      font-size: 3em;
    }

    h2{
      font-size: 2em;
    }

    a {
      font-size: 1.3em;
    }
  `}    background-size: auto;
`

const Wrapper = styled.div`
  padding: 3em 2em;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  box-sizing: border-box;

  ${breakpoint('tablet')`
    display: flex;
    text-align: left;
    justify-content: center;
  `}
`



const Header = ({ formUrl, multicanalidad, pais }) => (
  <Container>
    <Wrapper>
    <div style={{width:"100%"}}>
        <h1>Seguros y asistencias</h1><br></br>
        <h1>por tipo de Tarjeta</h1>
    </div>
    </Wrapper>
  </Container>
);

export default Header